/// <amd-module name="Analytics/Shared/FilterExpression" />

export function expr(expression: string): FilterExpression {
    return new FilterExpression(expression);
}

export function paren(expression: FilterExpression): FilterExpression {
    return new FilterExpression().paren(expression);
}

export class FilterExpression {
    public get and(): FilterExpression {
        return this.operator("and");
    }

    public get or(): FilterExpression {
        return this.operator("or");
    }
    private _expectExpr: boolean = true;
    private _expectOperator: boolean;

    public constructor(private _filterExpression?: string) {
        this._expectOperator = !!this._filterExpression;
        this._expectExpr = !this._filterExpression;
        this._filterExpression = this._filterExpression || "";
    }

    public expr(expression: string): FilterExpression {
        if (expression) {
            this.throwIfExprNotExpected();
            this._filterExpression += expression;
            this._expectOperator = true;
            this._expectExpr = false;
        }

        return this;
    }

    public paren(expression: FilterExpression): FilterExpression {
        if (expression) {
            this.throwIfExprNotExpected();
            this._filterExpression += `(${expression.toString()})`;
            this._expectExpr = false;
            this._expectOperator = true;
        }

        return this;
    }

    public toString(): string {
        return this._filterExpression!;
    }

    public reverseExprStatus(): FilterExpression {
        this._expectExpr = !this._expectExpr;
        return this;
    }

    private throwIfOperatorNotExpected() {
        if (!this._expectOperator) {
            throw new Error(`operator is not expected. Expression: ${this._filterExpression}`);
        }
    }

    private throwIfExprNotExpected() {
        if (!this._expectExpr) {
            throw new Error(`expression is not expected. Expression: ${this._filterExpression}`);
        }
    }

    private operator(op: string): FilterExpression {
        this.throwIfOperatorNotExpected();
        this._filterExpression += ` ${op} `;
        this._expectExpr = true;
        this._expectOperator = false;
        return this;
    }
}
